import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'UserBadge' })((theme) => ({
  root: {
    display: 'inline-block',
    paddingLeft: theme.spacing(1),
    verticalAlign: 'middle',
  },

  badge: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    height: '20px',
    width: '20px',
  },

  /***********************
   * ELEVATOR STAFF BADGE *
   ***********************/

  staffBackground: {
    backgroundColor: theme.palette.brands.elevator_red,
  },
  staffIcon: {
    height: '70%',
    color: theme.palette.common.white,
  },

  /**********************
   * PREFERRED BADGE *
   **********************/

  preferredIcon: {
    color: theme.palette.custom.yellow,
  },

  /**************************
   * VERIFIED BADGE *
   **************************/

  verifiedBadge: {
    height: '115%', // Larger than other icons since it has no background circle
    color: theme.palette.custom.blue.main,
  },

  /************
   * TOOLTIP *
   ************/
  tooltip: {
    position: 'relative',
    backgroundColor: theme.palette.common.black,
  },
  arrow: {
    position: 'absolute',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  tooltipPlacementBottom: {
    margin: '8px 0',
  },
  popper: {
    '&[x-placement*="bottom"] $arrow': {
      top: 5,
      left: 0,
      marginTop: '-1em',
      width: '2em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${theme.palette.common.black} transparent`,
      },
    },
  },
}));
